<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="close()">
  {{ title }}
</aionz-header-bottom-sheet>

<aionz-dialog-content class="dialog-content">
  @if (subtitle) {
    <p class="dialog-subtitle">{{ subtitle }}</p>
  }
  @for (option of options; track option.action) {
    <button
      type="button"
      class="option-card"
      [attr.aria-describedby]="'option-description-' + option.action"
      (click)="selectOption(option.action)">
      <span
        class="option-icon-wrapper"
        aria-hidden="true">
        <mat-icon>{{ option.icon }}</mat-icon>
      </span>

      <span class="option-title">{{ option.title }}</span>

      <span
        [id]="'option-description-' + option.action"
        class="option-description">
        {{ option.description }}
      </span>
    </button>
  }
</aionz-dialog-content>
